// All branches related apis
import { API_URL } from './api';
import instance from './api';
import { encryptData } from '../helpers/encryptDecrypt';

// Get api for fetching all branched for the active organization - (not in use since get organization is providing all the branches linked with it and the user)
export const fetchBranches = async (organizationId) => {
  const oId = encryptData(organizationId);
  
  const response = await instance.get(`${API_URL}/organizations/${oId}/branches`);
  return response.data;
};

// Post api for adding a new branch to the organization
export const addBranch = async (organizationId, branchData) => {
  const oId = encryptData(organizationId);
  return await instance.post(`${API_URL}/organizations/${oId}/branches`, branchData);
};

// Put api for updating the existing branch's details
export const updateBranch = async (organizationId, branchId, branchData) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);
  return await instance.put(`${API_URL}/organizations/${oId}/branches/${bId}`, branchData);
};

// Delete api for deleting the existing branch
export const deleteBranch = async (organizationId, branchId) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);
  return await instance.delete(`${API_URL}/organizations/${oId}/branches/${bId}`);
};
